module.exports = __webpack_public_path__ + "static/media/a8.ea0c7e4.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/suchunyuan/a8.mp3
// module id = 07It
// module chunks = 0